<div class="loading-container">
    <mat-spinner></mat-spinner>
    <p>Lade {{ name() }}...</p>
</div>